// actions types
export const CHANGE_LANGUAGE = '@@Config/changeLanguage'
